import * as addTemplate from '../services/addTemplate';

export default {
  namespace: 'addWmpTemplate',

  state: {
    // userInfo: null,
    // getMemberList: null,
    // addMember: null,
  },

  effects: {
    //模板详情
    *getTemplateDetail({ payload: { values }, callback }, { call, put }) {
      const response = yield call(addTemplate.getWmpTemplateDetail, values);
      yield put({
        type: 'save',
        payload: {
          templateDetail: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //模板消息详情
    *getTemplateMessageDetail(
      { payload: { values }, callback },
      { call, put },
    ) {
      const response = yield call(
        addTemplate.getWmpTemplateMessageDetail,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          templateMessageDetail: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //模板消息列表
    *getWechatTemplateMessageList(
      { payload: { values }, callback },
      { call, put },
    ) {
      const response = yield call(
        addTemplate.getWmpTemplateMessageList,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          wechatTemplateMessageList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //查询微信模板消息变量定义列表
    *getTempMsgVariableList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(addTemplate.getTempMsgVariableList, values);
      yield put({
        type: 'save',
        payload: {
          tempMsgVariableList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //新增模板消息
    *addTemplate({ payload: { values }, callback }, { call }) {
      const response = yield call(addTemplate.addWmpTemplate, values);
      if (response) {
        if (callback && typeof callback === 'function') {
          return callback(response);
        }
      }
      // yield put({
      //   type: 'save',
      //   payload: {
      //     addMember: response,
      //   },
      // });
    },
    //更新模板消息

    *updateTemplate({ payload: { values }, callback }, { call }) {
      const response = yield call(addTemplate.updateWmpTemplate, values);
      if (response) {
        if (callback && typeof callback === 'function') {
          return callback(response);
        }
      }
      // yield put({
      //   type: 'save',
      //   payload: {
      //     addMember: response,
      //   },
      // });
    },
    //获取appIdList
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
